import { SxProps } from '@mui/material/styles';

// Components
import Typography from 'Components/ds/Typography';

export interface MapleCardHeaderProps {
  title: string;
  sx?: SxProps;
}

const MapleCardHeader = ({ title, sx }: MapleCardHeaderProps) => {
  return (
    <Typography variant='h4' textAlign='center' weight='extraBold' sx={{ ...sx, pt: 5, pb: 3 }}>
      {title}
    </Typography>
  );
};

export default MapleCardHeader;
